import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetCustomerInvestmentSettingsRequest } from '@cash-web/shared-util-protos/squareup/franklin/investing.pb'
import { GetCustomerInvestmentSettingsResponse } from '@cash-web/shared-util-protos/squareup/franklin/investing.pb'

export const getCustomerInvestmentSettings = (
  request: GetCustomerInvestmentSettingsRequest,
  options?: CashRequestOptions
) =>
  post<GetCustomerInvestmentSettingsRequest, GetCustomerInvestmentSettingsResponse>(
    '/2.0/cash/get-customer-investment-settings',
    request,
    { ...options, rejectOnError: true }
  )
